import { render, staticRenderFns } from "./NotesCardDropdown.vue?vue&type=template&id=3ba0099e&"
import script from "./NotesCardDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotesCardDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports